<template>
  <div class="card d-flex justify-content-center mb-5">
    <div class="text-center p-4 rounded shadow-sm" style="background-color: #2c3e50;">
      <h1 class="text-white mb-0">{{ title }}</h1>
      <p class="text-light mt-2">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
}
</script>
